import { gql } from "@apollo/client";

export const GET_RISK_COMMENTS_QUERY = gql`
  query getRiskComments($documentId: Int!, $siteId: Int!) {
    getRiskComments(documentId: $documentId, siteId: $siteId) {
      riskCommentId
      freeTxt
      canDelete
      canEdit
      userId
      userName
      commentDate
      edited
    }
  }
`;
